/**
 * @file: frontCubeData前端渲染数据库
 * @author: xiaolong.huang@dmall.com
 */

import Utils from '../utils/util';

let frontDataMap: Map<CubeId, CubeFrontDataProxy> = new Map();
let cubeDepMap: Map<CubeId, DepMap> = new Map();

export function __dataGet__(cubeId: CubeId, key: string): any {
    return frontDataMap.get(cubeId)[key];
}

export function __allDataGet__(cubeId: CubeId): CubeFrontDataProxy {
    return frontDataMap.get(cubeId);
}

export function __allCube__(): Array<CubeId> {
    return Array.from(frontDataMap.keys());
}

export function __dataSet__(cubeId: CubeId, key: string, value: any): void {
    let cubeProxy: CubeFrontDataProxy = frontDataMap.get(cubeId);

    cubeProxy[key] = value;
}

export function __dataSetProxy__(cubeId: CubeId, proxy: CubeFrontDataProxy): void {
    frontDataMap.set(cubeId, proxy);
}

export function __depGet__(cubeId: CubeId): DepMap {
    return cubeDepMap.get(cubeId);
}

export function __depSet__(cubeId: CubeId, depMap: DepMap): void {
    cubeDepMap.set(cubeId, depMap);
}

export function __clear__(): void {
    frontDataMap.clear();
    cubeDepMap.clear();
}

export function __delete__(cubeId: CubeId): void {
    frontDataMap.delete(cubeId);
    cubeDepMap.delete(cubeId);
}

export function __hasKey__(cubeId: CubeId, key: string): boolean {
    let cubeProxy: CubeFrontDataProxy = frontDataMap.get(cubeId);

    return Utils.hasKey(cubeProxy, key);
}

export function __hasCube__(cubeId: CubeId): boolean {
    return frontDataMap.has(cubeId);
}
